import React, { useContext, useEffect, useState, useRef } from "react";
import { capitalize } from "lodash";
import FavoriteCheckbox from "../FavoriteCheckbox";
import { useHistory } from "react-router-dom";
import GlobalContext from "../../../context/GlobalContext";
import ImageGallery from "react-image-gallery";
import "./search-card.css";
import {
  numberWithCommas,
  setDecimalPoint,
  onImageError,
  onPropertyImageError,
  getTimeInterval,
  getOrderedImages,
} from "../../../utils";
import { abbrState } from "../../../utils/stateToAbbr";
import Timer from "../../molecules/Timer/timer";
import moment from "moment";
import PrimaryButton from "../../../components/atoms/PrimaryButton";
import { Gavel } from "@material-ui/icons";
import { getBidHistory } from "../../../API/propertyDetails";
import CustomDialog from "../CustomDialog";
import { ModalContext } from "../../../context/ModalContext";
import Tooltip from "@material-ui/core/Tooltip";

const SearchCard = (props) => {
  const history = useHistory();
  const { currentTime, bid } = useContext(GlobalContext);
  const { setLoginOpen, isLoginOpen, setSignupOpen, isSignupOpen } =
    useContext(ModalContext);
  const item = props.item;
  const [timer, setTimer] = useState({});
  const [buyTimer, setBuyTimer] = useState({});
  const [offerTimer, setOfferTimer] = useState({});
  const [propertyPhotos, setPropertyPhotos] = useState([]);
  const _currentTime = currentTime || props.timercurrent;
  const store_id = window.location.pathname.split("/")[1];
  const isMounted = useRef(true);

  // Cleanup when component unmounts
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (item?.all_images?.length > 0 && isMounted.current) {
      const baseImageURL = `${process.env.REACT_APP_IMAGE_URL}uploads/product/`;
      const orderedImages = getOrderedImages(
        item,
        item.all_images,
        baseImageURL,
      );

      setPropertyPhotos(
        orderedImages.map((data) => ({
          original: data.original,
          originalClass: "grid-card-img",
          originalHeight: "100%",
          originalWidth: "100%",
        })),
      );
    } else if (!item?.all_images || item?.all_images?.length === 0) {
      const baseImageURL = `${process.env.REACT_APP_IMAGE_URL}uploads/product/`;
      const orderedImages = getOrderedImages(item, [], baseImageURL);

      setPropertyPhotos(
        orderedImages.map((data) => ({
          original: data.original,
          originalClass: "grid-card-img",
          originalHeight: "100%",
          originalWidth: "100%",
        })),
      );
    }
  }, [item?.all_images, item?.avatar]);

  // useEffect(() => {
  //   if (item?.auction == 1 && _currentTime?.get) {
  //     setTimer(
  //       getTimeInterval(
  //         item["date_added"],
  //         item["date_closed"],
  //         _currentTime?.get,
  //         item["market_status"],
  //         "Auction"
  //       )
  //     );
  //   }
  //   if (item?.offer == 1 && _currentTime?.get) {
  //     setOfferTimer(
  //       getTimeInterval(
  //         item["o_date_added"],
  //         item["o_date_closed"],
  //         _currentTime.get,
  //         item["market_status"],
  //         "Offer"
  //       )
  //     );
  //   }
  //   if (item?.buynow == 1 && _currentTime?.get) {
  //     setBuyTimer(
  //       getTimeInterval(
  //         item["b_date_added"],
  //         item["b_date_closed"],
  //         _currentTime.get,
  //         item["market_status"],
  //         "Buy Now"
  //       )
  //     );
  //   }
  // }, [_currentTime?.get]);

  const [bidHistoryModal, setBidHistoryModal] = useState(false);
  const [bidHistory, setBidHistory] = useState([]);

  const handleBidHistory = async () => {
    let data = await getBidHistory({ id: item.id }, props.site_id);
    let bidsArr = data.result;
    if (isMounted.current) {
      setBidHistoryModal(true);
      setBidHistory(bidsArr);
    }
  };

  // const title = item?.sell_location
  //   ? item.sell_location?.split(" ").join("-")
  //   : `${item.loc_address.split(" ").join("-")}-${item?.loc_city
  //       ?.split(" ")
  //       .join("-")}-${
  //       abbrState(item.state, "abbr")
  //         ? abbrState(item.state, "abbr")
  //         : item.state
  //     }-${item.zipcode}`;

  const cleanString = (str) => {
    if (!str) return "";
    return str.replace(/\s+/g, "-").replace(/,/g, "");
  };
  const countWords = (text) => {
    return text ? text.trim().split(/\s+/).length : 0;
  };
  const isDragging = useRef(false);
  let startX = 0;

  const handleMouseDown = (e) => {
    isDragging.current = false;
    startX = e.clientX;
  };

  const handleMouseMove = (e) => {
    if (Math.abs(e.clientX - startX) > 5) {
      isDragging.current = true;
    }
  };

  const handleClick = (e) => {
    if (isDragging.current) return;
    if (e.target.closest(".image-gallery-icon")) return;
    goToProperty();
  };
  const [title, setTitle] = useState(() => {
    return [
      cleanString(item.loc_address),
      cleanString(item.loc_city),
      item?.county ? item.county : "",
      abbrState(item.state, "abbr") || item.state,
      item.zipcode,
    ]
      .filter(Boolean)
      .join("-");
  });
  const goToProperty = () => {
    const titleUrl = [
      cleanString(item.loc_address),
      cleanString(item.loc_city),
      abbrState(item.state, "abbr") || item.state,
      item.zipcode,
    ]
      .filter(Boolean)
      .join("-");

    const searchState = {
      fromSearch: true,
      searchURL: window.location.pathname + window.location.search,
    };
    if (item?.site_id === props.site_id) {
      if (props.showTimer) {
        history.push({
          pathname: `/property/${item.id}/${titleUrl}`,
          search: "",
          state: searchState,
        });
      } else {
        window.open(
          `${window.location.origin}/property/${item.id}/${titleUrl}`,
        );
      }
    } else {
      window.open(
        `${
          item?.domain !== "" ? item?.domain : "/" + item?.store_id
        }/property/${item?.id}/${titleUrl}`,
      );
    }
  };
  const titleUrl = [
    cleanString(item.loc_address),
    cleanString(item.loc_city),
    abbrState(item.state, "abbr") || item.state,
    item.zipcode,
  ]
    .filter(Boolean)
    .join("-");

  useEffect(() => {
    setTitle(
      [
        cleanString(item.loc_address),
        cleanString(item.loc_city),
        item?.county ? item.county : "",
        abbrState(item.state, "abbr") || item.state,
        item.zipcode,
      ]
        .filter(Boolean)
        .join("-"),
    );
  }, [item?.id]);

  return item?.id ? (
    <>
      <div className="upcomAuc">
        <div
          className="clickable-tile"
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onClick={handleClick}
          style={{ cursor: "pointer" }}
        >
          <div className="sc-top-wrap">
            <div className="timer-class">
              <Timer item={item} />
            </div>
            {propertyPhotos && propertyPhotos.length !== 0 && (
              <ImageGallery
                items={propertyPhotos}
                showThumbnails={false}
                showNav={true}
                showBullets={false}
                showFullscreenButton={false}
                showPlayButton={false}
                autoPlay={false}
                onErrorImageURL="/images/noimage.png"
                disableSwipe={true}
              />
            )}
          </div>

          <div className="cardDesc">
            <div className="favoriteList">
              <div
                className="favoriteList"
                onClick={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
              >
                <FavoriteCheckbox
                  project_id={item.id}
                  setLoginOpen={setLoginOpen}
                />
              </div>
            </div>
            <div className="listingType">
              {item.product_type !== "" && item.product_type != "None" ? (
                <span className="assetType">
                  {item.product_type.charAt(0).toUpperCase() +
                    item.product_type.slice(1)}
                </span>
              ) : null}
              {item.cash_only_flag === 1 ? (
                <span className="featuedType">Cash Only</span>
              ) : null}
            </div>
            <div className="d-flex justify-content-between">
              <Tooltip
                title={
                  (item.loc_address ? item.loc_address.length : 0) +
                    (item.loc_city ? item.loc_city.length : 0) +
                    (item.county ? item.county.length : 0) +
                    (item.state ? item.state.length : 0) +
                    (item.zipcode ? item.zipcode.toString().length : 0) >
                  95
                    ? `${item.loc_address}${
                        item.loc_city ? ", " + item.loc_city : ""
                      }${item.county ? ", " + item.county : ""}${
                        item.state
                          ? ", " + (abbrState(item.state, "abbr") || item.state)
                          : ""
                      }${item.zipcode ? ", " + item.zipcode : ""}`
                    : ""
                }
                placement="bottom"
                arrow
                disableHoverListener={
                  !(
                    (item.loc_address ? item.loc_address.length : 0) +
                      (item.loc_city ? item.loc_city.length : 0) +
                      (item.county ? item.county.length : 0) +
                      (item.state ? item.state.length : 0) +
                      (item.zipcode ? item.zipcode.toString().length : 0) >
                    95
                  )
                }
              >
                <h3
                  className={
                    props.from === "map" ? "map-address" : "card-address"
                  }
                  style={{
                    fontSize:
                      item.loc_address.length >= 24 &&
                      (item?.wprice?.toString().length >= 5 ||
                        item?.bprice?.toString().length >= 5 ||
                        item?.sprice?.toString().length >= 5)
                        ? "12px"
                        : "14px",
                    cursor:
                      item.loc_address &&
                      (item.loc_address.length > 105 ||
                        countWords(item.loc_address) > 3)
                        ? "pointer"
                        : "inherit",
                  }}
                >
                  {item.loc_address ? item.loc_address.split(",")[0] : ""},
                  <br />
                  <span className="itemLocCity">
                    {item.loc_city && `${item.loc_city}, `}
                    {abbrState(item.state, "abbr")
                      ? abbrState(item.state, "abbr")
                      : item.state}
                    {item.zipcode ? `, ${item.zipcode}` : ""}
                    <br />
                    {item.county ? `${item.county}` : ""}
                  </span>
                </h3>
              </Tooltip>
              {(item.offer_type === "Auction" && item.auction === 1) ||
              (item.offer_type === "Buynow" && item.buynow === 1) ? (
                <>
                  {item.offer_type !== "Auction" && item.auction !== 1 ? (
                    <div className="pricings">
                      <span className="currBid">Buy Now Price</span>
                      <span className="price">
                        ${setDecimalPoint(item.bprice)}
                      </span>
                    </div>
                  ) : (
                    <div className="pricings">
                      <span className="currBid">
                        {item.bidCount ? "Current Bid" : "Opening Bid"}
                      </span>
                      <span className="price">
                        {item.bidCount
                          ? `$${setDecimalPoint(item.wprice)}`
                          : item?.enable_start_price === "true"
                            ? `$${setDecimalPoint(item.sprice)}`
                            : "TBD"}
                      </span>
                    </div>
                  )}
                </>
              ) : null}
            </div>

            <div className="features mt-0">
              <ul className="d-flex align-items-center pl-0 justify-content-between mb-0">
                {item.bedroom_type && (
                  <li className="d-flex align-items-center">
                    <img src="/images/Bed.svg" alt="Bed Icon" />
                    {item.bedroom_type} Beds
                  </li>
                )}
                {item.bathroom && (
                  <li className="d-flex align-items-center">
                    <img src="/images/Bath.svg" alt="Bathtub Icon" />
                    {item.bathroom} Bath
                  </li>
                )}
                {item.sqrtarea > 0 && (
                  <li className="d-flex align-items-center">
                    <img src="/images/Square_Meters.svg" alt="Square Icon" />
                    {numberWithCommas(item.sqrtarea)}{" "}
                    {item.listing_type === 2 ? "Acres" : "sq ft."}
                  </li>
                )}
              </ul>
            </div>
            <hr className="cardLine" />
          </div>

          <div className="cardBottom" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex align-items-center justify-content-between">
              <PrimaryButton
                onClick={(e) => {
                  e.stopPropagation();
                  goToProperty();
                }}
              >
                {item.auction === 1 && item.buynow === 1
                  ? item?.auction_format === "inperson"
                    ? "Details"
                    : "Bid Now"
                  : item.auction === 1
                    ? item?.auction_format === "inperson"
                      ? "Details"
                      : "Bid Now"
                    : "View Property"}
              </PrimaryButton>

              {item?.auction_format === "inperson" ? (
                <div
                  className="d-flex align-items-center noOfBids"
                  style={{ cursor: "pointer" }}
                >
                  {capitalize(item?.occupancy_status)}
                </div>
              ) : (
                <div
                  className="d-flex align-items-center noOfBids"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleBidHistory();
                  }}
                >
                  <img src="/images/Line_Glyph.svg" /> {item.bidCount} Bids
                </div>
              )}
            </div>
          </div>
          {bidHistoryModal && (
            <CustomDialog
              title="Bid History"
              open={bidHistoryModal}
              dialogClass="bidHistoryModal"
              handleClose={() => setBidHistoryModal(false)}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Proposed amount</th>
                  </tr>
                </thead>
                <tbody>
                  {bidHistory?.length ? (
                    <>
                      {bidHistory?.map((data, index) => (
                        <tr key={index}>
                          <td>{data.name}</td>
                          <td>
                            {moment(data.created_at).format("MMM DD")} at{" "}
                            {moment(data.created_at).format("hh:mm A")}
                          </td>
                          <td>
                            {data.proposed_amount
                              ? `$${setDecimalPoint(
                                  parseInt(data.proposed_amount, 10),
                                )}`
                              : "-"}
                          </td>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CustomDialog>
          )}
        </div>
      </div>
    </>
  ) : null;
};

export default SearchCard;
